import { z } from 'zod';
import { lineAmount } from './oneTimeInvoice.js';
import { allAmounts, firstDueDate, recurrenceFor, repeat, } from './payments/payments.js';
export function buildRecurringRepeatSpec(startDate, dayOfMonth, intervalMonths, lines, currency = 'USD') {
    if (lines.length === 0) {
        throw new Error('buildRecurringRepeatSpec requires at least one line');
    }
    const firstDue = firstDueDate(startDate, Math.min(dayOfMonth, MAX_RECURRING_DAY_OF_MONTH));
    const amounts = lines.map((line) => lineAmount(line));
    return repeat(recurrenceFor('monthly', intervalMonths, firstDue), allAmounts(...amounts), currency, firstDue);
}
export const MAX_RECURRING_DAY_OF_MONTH = 28;
export const RECURRING_INVOICE_FREQUENCIES = ['monthly', 'quarterly', 'annually'];
export const RECURRING_FREQUENCY_INTERVAL_MONTHS = {
    monthly: 1,
    quarterly: 3,
    annually: 12,
};
export const recurringInvoiceFrequencySchema = z.enum(RECURRING_INVOICE_FREQUENCIES);
export const createRecurringInvoiceResultSchema = z.object({
    templateName: z.string(),
    frequency: recurringInvoiceFrequencySchema,
    dayOfMonth: z.number().int().min(1).max(MAX_RECURRING_DAY_OF_MONTH),
    template: z.discriminatedUnion('status', [
        z.object({ status: z.literal('created'), externalId: z.string() }),
        z.object({ status: z.literal('failed'), error: z.string() }),
    ]),
});
//# sourceMappingURL=recurringInvoice.js.map